import PonchoIcon from "./PonchoIcon";

export default function TramiteIcon({ ...props }) {
  return <PonchoIcon name="tramite" {...props} />;
}
